import { useCallback, useMemo } from 'react'
import * as dateFnsTZ from 'date-fns-tz'
import { toDate } from 'date-fns-tz'

const useTimezone = ({ utc } = {}) => {
  const userTimeZone = import.meta.env.VITE_APP_TIMEZONE

  const timeZone = useMemo(
    () => (utc ? 'UTC' : userTimeZone),
    [userTimeZone, utc]
  )

  const parseDate = useCallback(
    (value) => {
      if (!value) return
      const date = toDate(value)
      if (date.getUTCFullYear() <= 99) {
        throw Error('dates earlier than 0100-01-01 are not supported: ' + value)
      }
      return dateFnsTZ.toZonedTime(date, timeZone)
    },
    [timeZone]
  )

  const toISOString = (date) => {
    return fromZonedTime(date, timeZone).toISOString()
  }

  const toZonedTime = useCallback(
    (date, tz = timeZone, options = {}) => {
      return dateFnsTZ.toZonedTime(date, tz, options)
    },
    [timeZone]
  )

  const fromZonedTime = useCallback(
    (date, tz = timeZone, options = {}) => {
      return dateFnsTZ.fromZonedTime(date, tz, options)
    },
    [timeZone]
  )

  return {
    parseDate,
    timeZone,
    toISOString,
    toZonedTime,
    fromZonedTime,
  }
}

export default useTimezone
